import * as React from 'react';
import { EventCommunications } from './EventCommunications';
import type { Props } from './EventCommunications';

export const LazyEventCommunications = (props: Props) => <EventCommunications {...props} />;
